module.exports = __webpack_public_path__ + "static/media/twitter.2aa3876d.png";